module.exports = __webpack_public_path__ + "static/media/ki.80e19e9b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ki.svg
// module id = 952
// module chunks = 0